import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Portofolio.css';

export default function MantenimientoPredictivo() {
    return (
        <div className="portfolio-container">
            <Helmet>
                <title>Mantenimiento Predictivo Industrial | Navi</title>
                <meta name="description" content="Entrenamiento de redes neuronales locales para predecir fallos en maquinaria crítica, optimizando los tiempos de actividad en la fabricación de piezas de concreto." />
            </Helmet>

            {/* --- ENCABEZADO DEL PORTFOLIO --- */}
            <header className="portfolio-header">
                <span className="portfolio-category">SECTOR: INDUSTRIAL / FABRICACIÓN</span>
                <h1 className="portfolio-title">Mantenimiento Predictivo Industrial</h1>
                <h2 className="portfolio-subtitle">
                    Redes Neuronales locales vs. Paradas de Máquina. Anticipamos fallos en maquinaria crítica sin depender de la nube para garantizar soberanía y rapidez.
                </h2>
            </header>

            <div className="portfolio-hero-image">
                <img src="/imagenes_portofolio/Portofolio1_asset1.png" alt="Mantenimiento Predictivo Industrial" />
            </div>


            {/* --- CONTENIDO --- */}
            <div className="portfolio-content">
                <p>
                    En la industria de la fabricación, especialmente en sectores pesados como la producción de piezas de concreto, el tiempo es dinero. Las paradas de máquina no planificadas no solo detienen la producción, sino que generan cuellos de botella masivos.
                </p>

                <h3>El Enfoque: Anticipación mediante IA</h3>
                <p>
                    Nuestro objetivo no es reaccionar al fallo, sino <strong>predecirlo</strong>. Implementamos un sistema capaz de leer los sensores de la maquinaria en tiempo real para detectar anomalías microscópicas que el ojo humano o los sistemas tradicionales pasarían por alto.
                </p>

                <h3>La Tecnología y el Stack</h3>
                <p>
                    Para lograr esto, desarrollamos y entrenamos redes neuronales locales. Nuestro stack tecnológico principal para esta solución incluye:
                </p>
                <ul>
                    <li><strong>TensorFlow & Keras:</strong> Para el diseño y entrenamiento profundo de los modelos predictivos.</li>
                    <li><strong>Docker:</strong> Para contenerizar la solución y asegurar un despliegue rápido y robusto en las instalaciones del cliente.</li>
                </ul>

                <h3>El Diferencial: Edge Computing</h3>
                <p>
                    A diferencia de otras soluciones del mercado, la nuestra opera de forma completamente aislada si es necesario.
                </p>
                <blockquote className="portfolio-quote">
                    "No dependemos de la nube. Procesamos los datos localmente para garantizar una latencia cero y la soberanía total de la información industrial."
                </blockquote>

                <h3>El Impacto</h3>
                <p>
                    El resultado directo es una optimización drástica de los tiempos de actividad (uptime) en la planta, reduciendo los costes de mantenimiento correctivo y alargando la vida útil de los equipos más costosos.
                </p>

                {/* --- GIF DEMOSTRATIVO --- */}
                <figure className="portfolio-image-wrapper">
                    {/* Reemplaza esta ruta con la de tu GIF real */}
                    <img src="/imagenes_portofolio/Portofolio1_asset2.gif" alt="Demostración de predicción de fallos en tiempo real" />
                    <figcaption>Monitorización y predicción en tiempo real ejecutándose localmente.</figcaption>
                </figure>

                {/* --- CAJA DE LLAMADA A LA ACCIÓN (CTA) --- */}
                <div className="portfolio-cta-box">
                    <h3>¿Quieres optimizar el uptime de tu fábrica?</h3>
                    <p>Descubre cómo el mantenimiento predictivo local puede transformar tu producción sin comprometer tus datos.</p>

                    <button
                        className="cta-button"
                        onClick={() => window.open(
                            'https://wa.me/34624118531?text=%C2%A1Hola!%20Me%20interesa%20conocer%20m%C3%A1s%20sobre%20el%20Mantenimiento%20Predictivo%20Industrial.',
                            '_blank'
                        )}
                    >
                        Hablar con un experto en IA Industrial
                    </button>
                </div>
            </div>
        </div>
    );
}